/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdateTransferGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type UpdateTransferRequest = {
  /**
   * Identifier for the transfer.
   */
  transferID: string;
  accountID: string;
  patchTransfer: components.PatchTransfer;
};

export type UpdateTransferResponse = {
  headers: { [k: string]: Array<string> };
  result: components.Transfer;
};

/** @internal */
export const UpdateTransferGlobals$inboundSchema: z.ZodType<
  UpdateTransferGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type UpdateTransferGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const UpdateTransferGlobals$outboundSchema: z.ZodType<
  UpdateTransferGlobals$Outbound,
  z.ZodTypeDef,
  UpdateTransferGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function updateTransferGlobalsToJSON(
  updateTransferGlobals: UpdateTransferGlobals,
): string {
  return JSON.stringify(
    UpdateTransferGlobals$outboundSchema.parse(updateTransferGlobals),
  );
}
export function updateTransferGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<UpdateTransferGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateTransferGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateTransferGlobals' from JSON`,
  );
}

/** @internal */
export const UpdateTransferRequest$inboundSchema: z.ZodType<
  UpdateTransferRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  transferID: z.string(),
  accountID: z.string(),
  PatchTransfer: components.PatchTransfer$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "PatchTransfer": "patchTransfer",
  });
});
/** @internal */
export type UpdateTransferRequest$Outbound = {
  transferID: string;
  accountID: string;
  PatchTransfer: components.PatchTransfer$Outbound;
};

/** @internal */
export const UpdateTransferRequest$outboundSchema: z.ZodType<
  UpdateTransferRequest$Outbound,
  z.ZodTypeDef,
  UpdateTransferRequest
> = z.object({
  transferID: z.string(),
  accountID: z.string(),
  patchTransfer: components.PatchTransfer$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    patchTransfer: "PatchTransfer",
  });
});

export function updateTransferRequestToJSON(
  updateTransferRequest: UpdateTransferRequest,
): string {
  return JSON.stringify(
    UpdateTransferRequest$outboundSchema.parse(updateTransferRequest),
  );
}
export function updateTransferRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateTransferRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateTransferRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateTransferRequest' from JSON`,
  );
}

/** @internal */
export const UpdateTransferResponse$inboundSchema: z.ZodType<
  UpdateTransferResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.Transfer$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type UpdateTransferResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.Transfer$Outbound;
};

/** @internal */
export const UpdateTransferResponse$outboundSchema: z.ZodType<
  UpdateTransferResponse$Outbound,
  z.ZodTypeDef,
  UpdateTransferResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.Transfer$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function updateTransferResponseToJSON(
  updateTransferResponse: UpdateTransferResponse,
): string {
  return JSON.stringify(
    UpdateTransferResponse$outboundSchema.parse(updateTransferResponse),
  );
}
export function updateTransferResponseFromJSON(
  jsonString: string,
): SafeParseResult<UpdateTransferResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateTransferResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateTransferResponse' from JSON`,
  );
}
